import { applyMiddleware, createStore, compose, StoreEnhancer } from 'redux'
import createSagaMiddleware from 'redux-saga'
import env from '@beam-australia/react-env'
import { persistStore, persistReducer, PersistedState } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootSaga from './sagas'
import rootReducer from './reducers'

type RootState = ReturnType<typeof rootReducer>
type PersistedRootState = RootState & PersistedState

interface WindowWithDevTools extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (options: Record<string, unknown>) => typeof compose
}

const w = window as WindowWithDevTools
const devtools = w.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]
const composeEnhancers =
  env('NODE_ENV') !== 'production' &&
    Boolean(devtools) &&
    typeof window === 'object'
    ? devtools({})
    : compose

const persistConfig = {
  key: 'punchlist-pro-app',
  storage,
  blacklist: ['tosCheck'],
  migrate: (state: PersistedRootState | undefined): Promise<PersistedRootState> => {
    if (!state) {
      return Promise.resolve({} as PersistedRootState)
    }
    const newState: PersistedRootState = {
      ...state,
      config: state.config,
      tosCheck: false,
      invitations: state.invitations,
      orders: state.orders,
      territories: state.territories,
      tradeTypes: state.tradeTypes,
      user: { ...state.user },
      userReferrals: state.userReferrals,
      vendors: state.vendors,
      files: state.files
    }
    return Promise.resolve(newState)
  },
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middlewares)) as StoreEnhancer
)

const persistor = persistStore(store)

// Used to clean the storage that uses Redux Persist.
// persistor.purge()

sagaMiddleware.run(rootSaga)

const storeInfo = {
  store,
  persistor,
}

export default storeInfo
